export { default } from './MatchDetailsModal';
